import * as D from 'io-ts/Decoder';
import { PartnerDashboardData } from 'src/modules/partner-dashboard/types/PartnerDashboardData';

export const PARTNER_DASHBOARD_DATA: D.Decoder<unknown, PartnerDashboardData> = D.struct({
  url: D.string,
});
